import axios from 'axios';

import IMappingFormSettingsResponse from '../types/IMappingFormSettingsResponse';

const candidateSearch = '/candidatesearch/api/candidate-mapping';

export const candiateDefaultFieldMapping = () => axios.get(`${candidateSearch}/default`);

export const fetchCandiateFieldMapping = () => axios.get(`${candidateSearch}/fetch`);

export const saveCandiateFieldMapping = (payload: IMappingFormSettingsResponse) =>
  axios.post(`${candidateSearch}/save?`, payload);
